<template>
  <v-dialog
    v-model="$store.state.showCheckout"
  >
    <v-card class="pa-3">
      <div v-if="showSuccess">
        <v-row justify="center">
          <v-col
            cols="12"
          >
            <h3>Bestellung erfolgreich</h3>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col
            cols="12"
          >
            <div
              class="success-checkmark"
            >
              <div class="check-icon">
                <span class="icon-line line-tip" />
                <span class="icon-line line-long" />
                <div class="icon-circle" />
                <div class="icon-fix" />
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-row v-else>
        <v-col
          md="6"
          sm="12"
        >
          <v-list
            class="transparent pa-3"
          >
            <v-list-item
              v-for="item in cart.items"
              :key="item.id"
            >
              <v-list-item-icon>
                <v-img
                  class="white--text align-end"
                  :src="item.product.base_image.medium_image_url"
                  max-width="30px"
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-row>
                  <v-col>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>

                    <v-list-item-subtitle>
                      {{ item.quantity }} Stück á {{ item.formated_price }}
                    </v-list-item-subtitle>
                  </v-col>
                  <v-col>
                    <v-icon
                      right
                      @click="$store.dispatch('removeFromCard', item.id)"
                    >
                      mdi-minus-circle
                    </v-icon>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider class="my-2" />
          <div>
            Summe: {{ cart.formated_grand_total }}
          </div>
        </v-col>
        <v-col
          md="6"
          sm="12"
        >
          <v-stepper
            v-model="step"
            class="transparent"
          >
            <v-stepper-header>
              <v-stepper-step
                :complete="step > 1"
                step="1"
              >
                Liefermethode
              </v-stepper-step>

              <v-divider />

              <v-stepper-step
                :complete="step > 2"
                step="2"
              >
                Daten
              </v-stepper-step>

              <v-divider />

              <v-stepper-step step="3">
                Zahlung
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content
                v-if="pickuptimes.length"
                step="1"
              >
                <v-card

                  class="mb-12"
                >
                  <v-list>
                    <v-list-item-group
                      v-model="selected_shipping_method"
                      color="primary"
                    >
                      <v-list-item value="free_free">
                        <v-list-item-icon>
                          <v-icon />
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Abholung</v-list-item-title>
                          <v-list-item-subtitle>Hol dein Essen in der Lobis Café Bar ab</v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <v-select
                              v-model="address.pickuptime"
                              :items="pickuptimes"
                              label="Abholung um"
                              :error-messages="errors.pickuptime"
                            />
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        value="delivery"
                        disabled
                        inactive
                      >
                        <v-list-item-icon>
                          <v-icon />
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Zustellung</v-list-item-title>
                          <v-list-item-subtitle>In kürze Verfügbar</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>

                <v-btn
                  color="primary"
                  @click="confirmShipping"
                >
                  Weiter
                </v-btn>
              </v-stepper-content>
              <v-stepper-content
                v-else
                step="1"
              >
                <v-card

                  class="mb12"
                >
                  <v-card-text>Unsere Bar ist momentan leider geschlossen. Gerne sind wir morgen wieder für dich da.</v-card-text>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card
                  class="mb-12"
                >
                  <v-form
                    ref="form"
                    v-model="valid"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="address.first_name"
                          label="Vorname"
                          :error-messages="errors.first_name"
                          :rules="nameRules"
                        />
                      </v-col>
                      <v-col
                        cols="12"

                        md="6"
                      >
                        <v-text-field
                          v-model="address.last_name"
                          label="Nachname"
                          :error-messages="errors.last_name"
                          :rules="nameRules"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="address.email"
                          label="Email"
                          :error-messages="errors.email"
                          :rules="emailRules"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="address.phone"
                          label="Telefonnummer"
                          :error-messages="errors.phone"
                          :rules="phoneRules"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-textarea
                          v-model="address.note"
                          label="Bemerkung"
                          :error-messages="errors.note"
                          :rules="noteRules"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card>

                <v-btn
                  color="primary"
                  @click="confirmAddress"
                >
                  Weiter
                </v-btn>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-card
                  class="mb-12"
                >
                  <v-list class="transparent">
                    <v-list-item-group
                      v-model="selected_payment_method"
                      color="primary"
                    >
                      <v-list-item value="stripe">
                        <v-list-item-icon>
                          <v-icon>mdi-card</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Kreditkarte</v-list-item-title>
                          <v-list-item-subtitle>Einfach mit deiner Kreditkarte bezahlen</v-list-item-subtitle>
                          <v-list-item-subtitle v-if="selected_payment_method === 'stripe'">
                            <v-stripe-card
                              ref="stripeCard"
                              v-model="source"
                              api-key="pk_live_yFsqBn1rnUk59uSWoRDr8i6B00Gxxc1tSd"
                              :error-messages="errors.creditcard"
                            />
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item value="cashondelivery">
                        <v-list-item-icon>
                          <v-icon>mdi-cash</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Barzahlung bei Abholung</v-list-item-title>
                          <v-list-item-subtitle>Zahle einfach wenn du vorbei kommst deine Bestellung abzuholen</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
                <v-btn
                  color="primary"
                  :disabled="!selected_payment_method"
                  @click="saveOrder"
                >
                  Bestellung bestätigen
                </v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import VStripeCard from 'v-stripe-elements/lib/VStripeCard'

  export default {
    name: 'Checkout',
    components: { VStripeCard },

    data () {
      return {
        cartData: {
          items: [],
        },
        dialog: true,
        step: 1,
        valid: true,
        selected_shipping_method: 'free_free',
        selected_payment_method: null,
        source: null,
        errors: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          note: '',
          pickuptime: '',
          creditcard: '',
        },
        address: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          note: '',
          pickuptime: null,
          address1: {
            0: '',
          },
        },
        nameRules: [
          v => !!v || 'Name muss ausgefüllt werden',
        ],
        pickuptimeRules: [
          v => !!v || 'Abholzeit muss ausgefüllt werden',
        ],
        emailRules: [
          v => !!v || 'E-mail muss ausgefüllt werden',
          v => /.+@.+\..+/.test(v) || 'E-mail-Adresse nicht gültig',
        ],
        phoneRules: [
          v => !!v || 'Telefon muss ausgefüllt werden',
          v => /[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/.test(v) || 'Telefonnummer nicht gültig',
        ],
        noteRules: [
          v => v.length < 100 || 'Bemerkung darf nicht länger als 100 Zeichen sein',
        ],
        showSuccess: false,
        clientSecret: null,
      }
    },
    computed: {
      ...mapGetters([
        'showCheckout',
        'cart',
      ]),
      pickuptimes () {
        const times = []
        let start = new Date(new Date().setHours(7, 30))
        if (start < new Date()) {
          start = new Date()
        }
        for (let i = start.getHours(); i <= 15; i++) {
          if (i === 7) {
            times.push(i + ':' + '30')
            times.push(i + ':' + '45')
          }
          if (i === new Date().getHours()) {
            if (new Date().getMinutes() < 15) {
              times.push(i + ':' + '15')
            }
            if (new Date().getMinutes() < 30) {
              times.push(i + ':' + '30')
            }
            if (new Date().getMinutes() < 45) {
              times.push(i + ':' + '45')
            }
          } else if (i === 15) {
            times.push(i + ':' + '00')
            times.push(i + ':' + '15')
          } else {
            times.push(i + ':' + '00')
            times.push(i + ':' + '15')
            times.push(i + ':' + '30')
            times.push(i + ':' + '45')
          }
        }
        return times
      },
    },
    watch: {
      selected_payment_method: function () {
        this.savePayment()
      },
    },
    mounted () {
      this.getCartData()
    },
    methods: {
      getCartData () {
        // fetch('/api/checkout/cart')
        //   .then((response) => {
        //     return response.json()
        //   })
        //   .then((data) => {
        //     if (data.data) {
        //       this.cartData = data.data
        //     }
        //   })
      },
      confirmShipping (proceed = true) {
        if (!this.address.pickuptime) {
          this.errors.pickuptime = 'Abholzeit muss ausgefüllt werden.'
        } else {
          fetch('/api/checkout/save-shipping', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              accept: 'application/json',
            },
            body: JSON.stringify({
              shipping_method: 'free_free',
            }),
          })
            .then((response) => {
              return response.json()
            }).then((data) => {
              this.cartData = data.data.cart
              if (proceed) {
                this.step = 2
              }
            })
        }
      },
      confirmAddress () {
        if (!this.$refs.form.validate()) {
          return
        }
        var responseStatus = true
        fetch('/api/checkout/save-address', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
          body: JSON.stringify({
            billing: this.address,
            shipping: {
              address1: {
                0: '',
              },
            },
          }),
        })
          .then((response) => {
            if (!response.ok) {
              responseStatus = false
            }
            return response.json()
          }).then((data) => {
            if (responseStatus) {
              this.cartData = data.data.cart
              this.confirmShipping(false)
              this.step = 3
            } else {
              Object.keys(data.errors).forEach((error) => {
                this.errors[error.split('.')[1]] = data.errors[error].toString()
              })
            }
          })
      },
      savePayment () {
        this.errors.creditcard = ''
        fetch('/api/checkout/save-payment', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
          body: JSON.stringify({
            payment: {
              method: this.selected_payment_method,
            },
          }),
        })
          .then((response) => {
            return response.json()
          }).then((data) => {
            this.cartData = data.data.cart
            this.clientSecret = data.data.secret
            this.step = 3
          })
      },
      saveOrder () {
        if (this.selected_payment_method === 'stripe') {
          this.$refs.stripeCard.stripe.confirmCardPayment(this.clientSecret, {
            payment_method: {
              card: this.$refs.stripeCard.card,
              billing_details: {
                name: this.address.first_name + ' ' + this.address.last_name,
              },
            },
          }).then((result) => {
            if (result.error) {
              // Show error to your customer (e.g., insufficient funds)
              console.log(result.error.message)
              this.errors.creditcard = result.error.message
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                this.confirmOrder()
              }
            }
          })
        } else {
          this.confirmOrder()
        }
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      confirmOrder () {
        fetch('/api/checkout/save-order', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
          body: JSON.stringify({
            note: this.address.note,
            pick_up_time: this.address.pickuptime,
          }),
        })
          .then((response) => {
            return response.json()
          }).then((data) => {
            if (data.success) {
              this.showSuccess = true
              this.step = 1
              setTimeout(() => {
                this.showSuccess = false
                this.$store.dispatch('getCartData')
                this.$store.commit('hideCheckout')
              }, 3000)
            }
          })
      },
    },
  }
</script>

<style lang="scss" scoped>

.v-stepper, .v-sheet {
  box-shadow: none;
  -webkit-box-shadow: none;
}
/**
 * Extracted from: SweetAlert
 * Modified by: Istiak Tridip
 */
.success-checkmark {
    width: 80px;
    height: 115px;
    margin: 0 auto;

    .check-icon {
        width: 80px;
        height: 80px;
        position: relative;
        border-radius: 50%;
        box-sizing: content-box;
        border: 4px solid #4CAF50;

        &::before {
            top: 3px;
            left: -2px;
            width: 30px;
            transform-origin: 100% 50%;
            border-radius: 100px 0 0 100px;
        }

        &::after {
            top: 0;
            left: 30px;
            width: 60px;
            transform-origin: 0 50%;
            border-radius: 0 100px 100px 0;
            animation: rotate-circle 4.25s ease-in;
        }

        &::before, &::after {
            content: '';
            height: 100px;
            position: absolute;
            background: #FFFFFF;
            transform: rotate(-45deg);
        }

        .icon-line {
            height: 5px;
            background-color: #4CAF50;
            display: block;
            border-radius: 2px;
            position: absolute;
            z-index: 10;

            &.line-tip {
                top: 46px;
                left: 14px;
                width: 25px;
                transform: rotate(45deg);
                animation: icon-line-tip 0.75s;
            }

            &.line-long {
                top: 38px;
                right: 8px;
                width: 47px;
                transform: rotate(-45deg);
                animation: icon-line-long 0.75s;
            }
        }

        .icon-circle {
            top: -4px;
            left: -4px;
            z-index: 10;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            position: absolute;
            box-sizing: content-box;
            border: 4px solid rgba(76, 175, 80, .5);
        }

        .icon-fix {
            top: 8px;
            width: 5px;
            left: 26px;
            z-index: 1;
            height: 85px;
            position: absolute;
            transform: rotate(-45deg);
            background-color: #FFFFFF;
        }
    }
}

@keyframes rotate-circle {
    0% {
        transform: rotate(-45deg);
    }
    5% {
        transform: rotate(-45deg);
    }
    12% {
        transform: rotate(-405deg);
    }
    100% {
        transform: rotate(-405deg);
    }
}

@keyframes icon-line-tip {
    0% {
        width: 0;
        left: 1px;
        top: 19px;
    }
    54% {
        width: 0;
        left: 1px;
        top: 19px;
    }
    70% {
        width: 50px;
        left: -8px;
        top: 37px;
    }
    84% {
        width: 17px;
        left: 21px;
        top: 48px;
    }
    100% {
        width: 25px;
        left: 14px;
        top: 45px;
    }
}

@keyframes icon-line-long {
    0% {
        width: 0;
        right: 46px;
        top: 54px;
    }
    65% {
        width: 0;
        right: 46px;
        top: 54px;
    }
    84% {
        width: 55px;
        right: 0px;
        top: 35px;
    }
    100% {
        width: 47px;
        right: 8px;
        top: 38px;
    }
}
</style>
